/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Property subtypes represented independently of the base property type.
 */
export enum PropertySubtype {
    STUDIO = 'STUDIO',
}
